const requirement  = {
      state: {
        requireList:{}
      },
      getters: {},
      mutations: {
        add(state, data) {
            state.requireList = data
            console.log(state.requireList,'----98');
        },
        clear(state) {
          state.requireList ={}
        }

      },
      actions: {
        add({ commit }, data) {
          commit('add', data)
        },
        clear({ commit }) {
          commit('clear')
        }
      }
    }
export default requirement;


// WEBPACK FOOTER //
// ./src/store/modules/requirement.js